export const personalProjects = [
  {
    title: "Personal Website",
    features: [
      "Terminal-style design theme with interactive command-inspired UI elements",
      "Gamified experiences including a basketball mini-game with physics, scoring, and leaderboard",
      "Interactive road timeline to showcase experiences, featuring animated car, progress bar, and scroll-triggered animations",
      "Dynamic dark/light mode support across all pages for accessibility and modern UI feel",
      "Smooth animations and transitions (fade-ins, hover effects, swaying net, spinning wheels) enhancing user engagement",
      "Integrated contact system with clickable commands (git clone, mail -s) and resume download",
      "Responsive, mobile-friendly layout built with React + Tailwind for seamless cross-device performance"
    ],
    techStack: ["React", "Tailwind CSS", "JavaScript", "Github", "Vercel"],
    images: [
      "/personal_project_images/website1.png",
      "/personal_project_images/website2.png",
      "/personal_project_images/website3.png",
      "/personal_project_images/website4.png",
      "/personal_project_images/website5.png",
      "/personal_project_images/website6.png",
      "/personal_project_images/website7.png",
      "/personal_project_images/website8.png"
    ],
    links: {
      github: "https://github.com/Anahat07/personal-portfolio",
    }
  },
  {
    title: "Keyframe Animation Project",
    features: ["Linear Interpolation & Matrix Transformations: Applied mathematical techniques to achieve smooth transitions and transformations in animations.",
      "Spherical Linear Interpolation (SLERP): Used SLERP for precise rotational movements in character animations.",
      "Linear Blend Skinning: Implemented this technique for realistic mesh deformations and smooth character movement.",
      "Python & Blender Integration: Leveraged Python libraries (NumPy, Polyscope) alongside Blender for advanced animation control and rendering."],
    techStack: ["Python", "NumPy", "Polyscope", "Computer Animations", "Mathematical Equations"],
    images: ["/personal_project_images/keyframe-animation-1.png",
      "/personal_project_images/keyframe-animation-2.png",
      "/personal_project_images/keyframe-animation-3.png",
    ],
    links: {
      demo: "https://docs.google.com/presentation/d/1Tjq1hHnqh-1auE-Mv4xq-QWb85cvdgqh/edit?usp=sharing&ouid=110204279666856671051&rtpof=true&sd=true"
    }
  },
  {
    title: "NLP + Finance",
    features: ["Sentiment Analysis: Utilized logistic regression, LSTMs, and BERT to analyze and interpret the sentiment of financial tweets.",
      "Stock Market Trend Prediction: Leveraged sentiment data to predict long-term trends in the stock market.",
      "NLP Techniques: Applied advanced Natural Language Processing methods for accurate text analysis and prediction.",
      "Project Integration: Merged finance and AI technologies to create a socially impactful tool for financial decision-making."],
    techStack: ["LSTMs", "Machine Learning", "Linear & Logistic Regression", "Neural Networks", "NLP", "Bert", "Artificial Intelligence"],
    images: ["/personal_project_images/nlp-finance-1.png",
      "/personal_project_images/nlp-finance-2.png",
      "/personal_project_images/nlp-finance-3.png",
      "/personal_project_images/nlp-finance-4.png",
    ],
    links: {
      demo: "https://docs.google.com/presentation/d/14wmVKMickgSyLHJBajf3hmfiI5cHEF52/edit?usp=sharing&ouid=110204279666856671051&rtpof=true&sd=true"
    }
  },
  {
    title: "CityLens",
    features: [
      "Urban-Mapping Platform: Built at IBM x UNSA Hackathon 2026 to visualize climate inequity at the city-block level across Toronto.",
      "Multi-Layer Data Overlay: Combined heat, air quality, flood risk, tree canopy, and median income data to surface where environmental vulnerability overlaps with underinvestment.",
      "Geospatial Architecture: Built with Next.js, React, Tailwind, Mapbox GL JS, FastAPI, and PostgreSQL/PostGIS, integrating OpenAQ, NASA FIRMS, Sentinel Hub, and Toronto Open Data for real-time block-level insights.",
      "AI-Powered Block Analysis: Used IBM watsonx.ai (Granite 3 8B Instruct) and Featherless AI (Qwen) to generate heat-risk classifications, planner-friendly summaries, and ranked interventions with projected temperature reduction, cost, and ROI.",
      "Equity Analysis Pipeline: Built a Python pipeline correlating census income deciles with deployed-resource counts to flag high-risk, low-resource blocks.",
      "Advocacy Tool: Developed a React-PDF petition generator letting residents export council-ready documents pre-filled with AI-generated summaries and vulnerability scores."
    ],
    techStack: ["Next.js", "React", "Tailwind CSS", "Mapbox GL JS", "FastAPI", "PostgreSQL", "PostGIS", "IBM watsonx.ai", "Python"],
    images: [
      "/personal_project_images/citylens-1.png",
      "/personal_project_images/citylens-2.png",
    ],
    links: {
      devpost: "https://devpost.com/software/citylens-xk6bsa",
      github: "https://github.com/eszain/CityLens"
    }
  },
  {
    title: "Curas.ai",
    features: [
      "Agentic AI System: Built to reduce administrative burden for Ontario family physicians by automating clinical documentation across the full appointment lifecycle.",
      "Three-Phase Orchestration: Designed a pipeline using IBM watsonx Granite and IBM Orchestrate spanning pre-appointment context retrieval, real-time transcription, and post-appointment form generation.",
      "Pre-Appointment Context Engine: Retrieved EMR data via SMART on FHIR APIs to generate structured patient summaries and detect missing data.",
      "Real-Time Active Scribe: Streamed transcription with faster-whisper and drafted SOAP notes, OHIP billing codes, and lab requisitions during consultations.",
      "Post-Appointment Form Originator: Mapped clinical data to complex forms (e.g., T2201 Disability Tax Credit Certificate) with confidence scoring and physician review workflows.",
      "Modular Architecture: Combined a React + Vite physician dashboard, FastAPI backend coordinated via IBM Orchestrate, Supabase PostgreSQL with append-only versioned audit logs, SSE for real-time streaming, and Pydantic schema validation.",
      "Responsible AI Design: Incorporated human-in-the-loop approvals, confidence thresholds, auditability, and controlled EMR writeback for clinical safety and transparency."
    ],
    techStack: ["React", "Vite", "FastAPI", "IBM watsonx", "IBM Orchestrate", "Supabase", "PostgreSQL", "Pydantic", "faster-whisper"],
    images: [
      "/personal_project_images/curas-1.png",
      "/personal_project_images/curas-2.png",
      "/personal_project_images/curas-3.png",
      "/personal_project_images/curas-4.png",
    ],
    links: {
      demo: "https://drive.google.com/file/d/1181m7vnedaudCxY1LN6NMcoJ6nKwGj91/view",
      github: "https://github.com/juanferdenUni/IBM_AI_Lab"
    }
  }
];